/**
 * The real Auth0 provider, configured exactly as the original main.tsx.
 *
 * Its own file so `AuthProvider` stays a pure selector between this and the
 * dev-only preview provider — one component per file.
 */
import { Auth0Provider } from '@auth0/auth0-react';
import type { ReactNode } from 'react';

export function RealAuth0Provider({ children }: { children: ReactNode }) {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      }}
    >
      {children}
    </Auth0Provider>
  );
}

export default RealAuth0Provider;
